<template>
  
  <BaseModal ref="baseModalRef" v-bind="childProps">

    <template v-slot:body>
        <VueDaumPostcode ref="daumPostcode" @complete="getDaumPostcode" :key="daumModalKey"/>
    </template>

  </BaseModal>
  

</template>

<script setup>
import {ref,reactive} from 'vue'
// 라이브러리 설치 후 선언 (npm install --save vue-daum-postcode)
import {VueDaumPostcode} from 'vue-daum-postcode'
import BaseModal from '@/components/common/modal/BaseModal.vue';

const daumModalKey = ref(1)
//const setAddress = ref()
const emits = defineEmits(['return','em_address'])

const daumPostcode = ref()
const baseModalRef = ref()

const state = reactive({
    postcode: "",
    address: "",
 })

const childProps = ref({
  modalId : 'address',
  modalNm : '주소찾기',
  size: 'lg'
})

 //선택한 주소 데이터 처리 함수
function getDaumPostcode(data){
  // 우편번호
  state.postcode = data.zonecode

  // 도로명을 선택했을 경우.
  if (data.userSelectedType === "R") {
    state.address = data.roadAddress 
    if(data.buildingName != '' && data.buildingName != null && data.buildingName != undefined){
    state.address +=  '(' + data.buildingName + ')'
    }
  } else {
  // 지번(data.userSelectedType === "J")을 선택했을 경우.
    state.address = data.jibunAddress
  }


  let addr = {
  address : state.address,
  postcode : data.zonecode,
  buildingName : data.buildingName,
  jibunAddress : data.jibunAddress
  }


  emits('em_address',addr) 
  closeModal()
}


function openModal(){
  daumModalKey.value += 1
  baseModalRef.value.openModal()
}

function closeModal(){
  baseModalRef.value.closeModal()
}

defineExpose({
  openModal
})


</script>
